/*
 * A.J. Martin Originals collection grid: "Designs Available for Custom Order" (2026-10-21, owner:
 * the design applies to any product in the collection with more than one variant). The USF card
 * template carries data-ajm-variants (assets/usf.js); CSS `order` in overrides.css shows the
 * single-variant pieces first, then this heading, then the multi-variant designs, the piece-alert
 * card last. Only the heading is inserted, never a card moved, so USF's redraws stay intact.
 * Loaded only on that collection (layout/theme.liquid).
 */
(function () {
  'use strict';

  var CONTAINER_SELECTOR = '#usf_container';
  var GRID_SELECTOR = '.new-grid, .usf-grid';
  var DESIGN_SELECTOR = '.usf-sr-product[data-ajm-variants]:not([data-ajm-variants="0"]):not([data-ajm-variants="1"])';
  var DIVIDER_CLASS = 'custom-order-grid-divider';
  var DIVIDER_LABEL = 'Designs Available for Custom Order';

  document.documentElement.classList.add('ajm-custom-order-grid');

  function buildDivider() {
    var divider = document.createElement('div');
    divider.className = DIVIDER_CLASS;
    divider.setAttribute('aria-hidden', 'true');
    divider.innerHTML =
      '<span class="' + DIVIDER_CLASS + '__line"></span>' +
      '<span class="' + DIVIDER_CLASS + '__label">' + DIVIDER_LABEL + '</span>' +
      '<span class="' + DIVIDER_CLASS + '__line"></span>';
    return divider;
  }

  function syncDivider() {
    var container = document.querySelector(CONTAINER_SELECTOR);
    if (!container) return;

    var grid = container.querySelector(GRID_SELECTOR);
    if (!grid) return;

    var hasDesigns = !!grid.querySelector(DESIGN_SELECTOR);
    var existing = grid.querySelector('.' + DIVIDER_CLASS);

    if (!hasDesigns) {
      if (existing) existing.remove();
      return;
    }
    if (!existing) grid.appendChild(buildDivider());
  }

  var scheduleTimer = null;
  function schedule() {
    if (scheduleTimer) return;
    scheduleTimer = setTimeout(function () {
      scheduleTimer = null;
      syncDivider();
    }, 50);
  }

  var observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });

  schedule();
})();
